/* eslint-disable jsdoc/require-param-type */
/* eslint-disable jsdoc/require-param-description */
/* eslint-disable jsdoc/require-returns */
import { combineLatest } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import { SHARED_WEB_ASSETS_URL } from '../../../app.constants';
import { Component, OnInit, Renderer2, Inject, NgZone, ElementRef, Output, EventEmitter } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { NavigationEnd, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { AnalyticsUtil } from '../../../utils/analytics.util';
import { MyAccountState } from '../../../store/state/my-account.state';
import { setAppConfig } from '../../../utils/app.config.util';
import { HeaderApi } from '../../../interfaces/header-api.interface';
import { LayoutService } from 'src/app/services/layout.service';

declare global {
    interface Window { Unit4Header: HeaderApi }
}

@Component({
    selector: 'u4-cpp-header',
    templateUrl: './header.component.html'
})
export class HeaderComponent implements OnInit {
    /**
     * Indicates whether the header is loaded.
     */
    @Output() loaded = new EventEmitter<boolean>();

    /**
     * The HTML of the global community header.
     */
    public html: SafeHtml;


    constructor(
        private elementRef: ElementRef,
        private router: Router,
        private ngZone: NgZone,
        private analyticsUtil: AnalyticsUtil,
        private store: Store<MyAccountState>,
        private layoutService: LayoutService,
        private renderer: Renderer2,
        private domSanitizer: DomSanitizer,
        @Inject(DOCUMENT) private document: Document,
    ) {}

    ngOnInit() {
        this.render();
    }

    /**
     * Render the global site header.
     */
    render() {
        const assetsUrl = `${SHARED_WEB_ASSETS_URL}/dist`;

        combineLatest([
            this.layoutService.getHeader(),
            this.store.select(state => state.profile).pipe(
                filter(val => Object.keys(val).length > 0)
            )
        ]).pipe(
            take(1)
        ).subscribe(([html, profile]) => {
            setAppConfig('USER', btoa(unescape(encodeURIComponent(JSON.stringify(profile)))));
            this.html = this.domSanitizer.bypassSecurityTrustHtml(html as string);
            this.renderElement('script', {
                type: 'text/javascript',
                src: `${assetsUrl}/shared.min.js`
            }).addEventListener('load', () => {
                this.bindRouter();
                this.loaded.emit(true);
            });

            this.analyticsUtil.trackUser(profile);
        });

        this.renderElement('link', {
            type: 'text/css',
            rel: 'stylesheet',
            href: `${assetsUrl}/shared.min.css`
        }, this.document.head);
    }

    /**
     * Create and append an element tag.
     * @param name
     * @param props
     * @param target
     */
    renderElement(name: string, props: {[key: string]: unknown}, target = this.document.body): HTMLElement {
        const elem = this.renderer.createElement(name) as HTMLElement;

        Object.keys(props).forEach(key => elem[key] = props[key]); // assign properties

        this.renderer.appendChild(target, elem);

        return elem;
    }

    /**
     * Bind the router to the header navigation events.
     */
    bindRouter() {
        window.Unit4Header.onNavigate((path) => {
            this.ngZone.run(() => {
                void this.router.navigate([path]);
            });
        });

        this.router.events.pipe(
            filter(e => e instanceof NavigationEnd)
        ).subscribe(() => {
            window.Unit4Header.updateMenu();
        });
    }
}
